import React from 'react';

const Blog = () => {
    return (
        <div style={{textAlign: 'center',backgroundColor:'white',height:'100px',marginTop:'3%'}}>
            <h3>My Blog</h3>
            <h4>cooming soon</h4>
        </div>
    );
};

export default Blog;